module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/creditos/tabla-amortizacion/tabla-amortizacion.component.scss
// module id = ./src/app/creditos/tabla-amortizacion/tabla-amortizacion.component.scss
// module chunks = main